module.exports = "pegasus/assets/hexline-youtube.png";